import { render, staticRenderFns } from "./KikoFlying.vue?vue&type=template&id=db9a289e&scoped=true"
import script from "./KikoFlying.vue?vue&type=script&lang=js"
export * from "./KikoFlying.vue?vue&type=script&lang=js"
import style0 from "./KikoFlying.vue?vue&type=style&index=0&id=db9a289e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9a289e",
  null
  
)

export default component.exports